<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qHrkAF/images/cover.jpg?1685327319615" alt="This image is the cover for the book Fireheart, The Evolin Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fireheart, The Evolin Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Evolin: Book One</i></b></p><p>In a world where magic is outlawed, Tylanovaar must hide his true identity. As a young prince about to be married, the last thing his people can find out is that he has the gift of fire in his veins.</p> <p>But when he meets the man hired to turn him into a suitable heir for the throne, he’s forced to keep another secret.</p> <p>Sully is an elite lawkeeper called a Rider. When a young man he meets by chance ends up being the Prince of Evolin, Sully becomes his tutor at the king’s request. Tylan fascinates him, and a journey to help Tylan learn to control his magic gives them time alone, but not enough. They take ever greater risks to be together until they are caught in Sully’s bed on Tylan’s wedding night, causing Tylan to lose the fragile hold he has over his gift.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kay Ellis
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e344c7e